import { Button, ButtonGroup } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { LANDING_PRIMITIVE_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { components } from "src/modules/pe-landing-module/data/utils/components"

/* Protopia Ecosystem component */
export interface IFloatsSelectorListProps {
   
}
const FloatsSelectorList = (props: IFloatsSelectorListProps): JSX.Element => {
    return <div className='pe-floats-selector-list overflow-y-auto-thin'>
       <div className="float-list">
            <ButtonGroup fill vertical>
                {
                    Object.values( LANDING_PRIMITIVE_TYPE ) 
                    .map( key => {
                        return <Button variant="minimal" className="btn-stretch hover" key={key}>
                            <div className="d-flex w-100">
                                <img
                                    src={ `/assets/img/landing/${key}.svg` }
                                    alt=""
                                    className="icon mr-1"
                                    height={12}
                                />
                                <div className="d-flex small text-light ">
                                    <div className="small">
                                        { __(key) }
                                    </div>
                                </div>
                            </div>
                            
                        </Button>
                    } )
                }
                {
                    Object.keys( components() )
                    .filter( key => !!components()[key].primitive )
                    .map( key => {
                        return <Button variant="minimal" className="btn-stretch hover" key={key}>
                            <div className="d-flex w-100">
                                <img
                                    src={ components()[ key ].icon }
                                    alt=""
                                    className="icon mr-1"
                                    height={12}
                                />
                                <div className="d-flex small text-light ">
                                    <div className="small">
                                        { __(components()[ key ].title) }
                                    </div>
                                </div>
                            </div>
                            
                        </Button>
                    } )
                }
            </ButtonGroup>
       </div>
    </div>
}
export default FloatsSelectorList